import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    height: '42.63px',
    '& .MuiInputBase-root': {
      height: '100%',
      boxSizing: 'border-box',
    },
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
      height: '100% !important',
      minHeight: '0 !important',
      boxSizing: 'border-box',
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
    },
    '& .Mui-disabled': {
      borderRadius: "8px !important",
      borderColor: "#dfdfdf",
      backgroundColor: '#efefef !important',
      color: "#9e9e9e",
      '&.MuiSelect-icon': {
        right: 2
      }
    },
  },
  
  label: {
    fontSize: '13px',
    color: '#455a64',
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, 1.5px) scale(1)',
      },
    },
    '& .MuiSelect-select:focus': {
      borderRadius: 8,
      
    },
  },
  asterisk: {
    color: '#ef5350',
  },
}));
